import dayjs from "dayjs";

const NO_OBSOLESCENCE_YEAR = 9999;

export const isNoObsolescenceDate = (
  value: string | number | null | undefined,
): boolean => {
  if (value == null || value === "") return true;
  const parsed = dayjs(value);
  return parsed.isValid() && parsed.year() >= NO_OBSOLESCENCE_YEAR;
};
